import { defineStore } from 'pinia';

export const useProjectStore = defineStore('project', () => {
  let projectUid = '';

  const setProjectUid = (uid: string): void => {
    projectUid = uid;
  };

  const getProjectUid = () => projectUid;

  return { setProjectUid, getProjectUid };
});
